import { createAction } from '@reduxjs/toolkit';

import { SEARCH } from 'store/constants/actions';

export const setCurrentSearchTerm = createAction<string | 'TERM_UNKOWN'>(
  SEARCH.SET_CURRENT_SEARCH_TERM,
);
